import gql from 'graphql-tag';

export default gql`
  subscription RefreshPortfolioBalances($portfolioId: ID!) {
    refreshPortfolioBalances(portfolioId: $portfolioId)
  }
`;
